'use client';

import classNames from 'classnames';

import { KarmaPoint } from '@ui/uikit/components/icons/mono/KarmaPoint';
import { Tabular } from '@ui/uikit/primitives/Tabular';

export const EstimatedKarmaInfo = ({
  estimatedKarma,
  isDataStale,
}: {
  estimatedKarma: number;
  isDataStale: boolean;
}) => {
  return (
    <div className="rounded-[16px] p-[16px] bg-secondary-100 border-2 border-secondary-100">
      <Tabular className="tabular-uniform [&>.label]:text-neutral-600 [&>.content]:text-neutral-400">
        <Tabular.Row label="You will recieve">
          <span
            className={classNames('flex gap-1 justify-center items-center', {
              'animate-pulse-4x': isDataStale,
            })}
          >
            <span className="chip py-1 px-2 gap-1 bg-secondary-500 text-base-text-white">
              <KarmaPoint className="w-[10px]" />{' '}
              <span className="opacity-80 text-[12px] font-medium">{estimatedKarma}</span>
            </span>
            <span>Karma Points</span>
          </span>
        </Tabular.Row>
      </Tabular>
    </div>
  );
};
